import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { taskId: Number }

  dragstart(event) {
    event.dataTransfer.setData('text/plain', this.taskIdValue)
    event.dataTransfer.setData('application/x-quadrant', this.element.dataset.quadrant)
    event.dataTransfer.effectAllowed = 'move'
    this.element.classList.add('opacity-50')
  }

  dragend() {
    this.element.classList.remove('opacity-50')
    const indicator = document.getElementById('drop-indicator')
    if (indicator) indicator.remove()
  }
}
